import { useState } from 'react'
import { ButtleFlowStep1 } from './ButtleFlowStep1'
import { ButtleFlowStep2 } from './ButtleFlowStep2'
import { ButtleFlowStep3 } from './ButtleFlowStep3'
import { ButtleFlowStep4 } from './ButtleFlowStep4'
import { ButtleFlowStep5 } from './ButtleFlowStep5'

export const BattleFlow = () => {
    const [activeBattleFlow, setActiveBattleFlow] = useState('step1')
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }

    return (
        <>
            <nav className='mx-auto my-8'>
                <ul className='[&>li>img]:mx-auto [&>li>img]:w-full  [&>li]:w-[47%] [&>li]:md:w-[25%] cursor-pointer flex justify-center gap-4 flex-wrap mx-auto px-4 md:px-0 max-w-[1200px] items-end'>
                    <li>
                        <img
                            onClick={() => {
                                setActiveBattleFlow('step1')
                                scrollToTop()
                            }}
                            className={` ${
                                activeBattleFlow === 'step1' && 'brightness-125'
                            }  mx-auto hover:brightness-125 duration-300`}
                            alt='system basics'
                            src={`${process.env.PUBLIC_URL}/images/system/header-step1.webp`}
                        />
                    </li>
                    <li>
                        <img
                            onClick={() => {
                                setActiveBattleFlow('step2')
                                scrollToTop()
                            }}
                            className={` ${
                                activeBattleFlow === 'step2' && 'brightness-125'
                            }  hover:brightness-125 duration-300`}
                            alt='confire'
                            src={`${process.env.PUBLIC_URL}/images/system/header-step2.webp`}
                        />
                    </li>
                    <li className='relative inline-block '>
                        <img
                            onClick={() => {
                                setActiveBattleFlow('step3')
                                scrollToTop()
                            }}
                            className={` ${
                                activeBattleFlow === 'step3' && 'brightness-125'
                            }  hover:brightness-125 duration-300`}
                            alt='confriend'
                            src={`${process.env.PUBLIC_URL}/images/system/header-step3.webp`}
                        />{' '}
                    </li>{' '}
                    <li>
                        {' '}
                        <img
                            onClick={() => {
                                setActiveBattleFlow('step4')
                                scrollToTop()
                            }}
                            className={` ${
                                activeBattleFlow === 'step4' && 'brightness-125'
                            }  hover:brightness-125 duration-300`}
                            alt='step4'
                            src={`${process.env.PUBLIC_URL}/images/system/header-step4.webp`}
                        />
                    </li>
                    <li>
                        {' '}
                        <img
                            onClick={() => {
                                setActiveBattleFlow('step5')
                                scrollToTop()
                            }}
                            className={` ${
                                activeBattleFlow === 'step5' && 'brightness-125'
                            }  hover:brightness-125 duration-300`}
                            alt='step5'
                            src={`${process.env.PUBLIC_URL}/images/system/header-step5.webp`}
                        />
                    </li>
                </ul>
            </nav>
            <div className='max-w-[1200px] mx-auto my-12 md:my-20'>
                {(() => {
                    switch (activeBattleFlow) {
                        case 'step1':
                            return <ButtleFlowStep1 />
                        case 'step2':
                            return <ButtleFlowStep2 />
                        case 'step3':
                            return <ButtleFlowStep3 />
                        case 'step4':
                            return <ButtleFlowStep4 />
                        case 'step5':
                            return <ButtleFlowStep5 />

                        default:
                            return null
                    }
                })()}
            </div>{' '}
            <nav className='mx-auto my-8'>
                <ul className='[&>li>img]:mx-auto [&>li>img]:w-full  [&>li]:w-[47%] [&>li]:md:w-[25%] cursor-pointer flex justify-center gap-4 flex-wrap mx-auto px-4 md:px-0 max-w-[1200px] items-end'>
                    <li>
                        <img
                            onClick={() => {
                                setActiveBattleFlow('step1')
                                scrollToTop()
                            }}
                            className={` ${
                                activeBattleFlow === 'step1' && 'brightness-125'
                            }  mx-auto hover:brightness-125 duration-300`}
                            alt='system basics'
                            src={`${process.env.PUBLIC_URL}/images/system/header-step1.webp`}
                        />
                    </li>
                    <li>
                        <img
                            onClick={() => {
                                setActiveBattleFlow('step2')
                                scrollToTop()
                            }}
                            className={` ${
                                activeBattleFlow === 'step2' && 'brightness-125'
                            }  hover:brightness-125 duration-300`}
                            alt='confire'
                            src={`${process.env.PUBLIC_URL}/images/system/header-step2.webp`}
                        />
                    </li>
                    <li className='relative inline-block '>
                        <img
                            onClick={() => {
                                setActiveBattleFlow('step3')
                                scrollToTop()
                            }}
                            className={` ${
                                activeBattleFlow === 'step3' && 'brightness-125'
                            }  hover:brightness-125 duration-300`}
                            alt='step3'
                            src={`${process.env.PUBLIC_URL}/images/system/header-step3.webp`}
                        />{' '}
                    </li>{' '}
                    <li>
                        {' '}
                        <img
                            onClick={() => {
                                setActiveBattleFlow('step4')
                                scrollToTop()
                            }}
                            className={` ${
                                activeBattleFlow === 'step4' && 'brightness-125'
                            }  hover:brightness-125 duration-300`}
                            alt='step4'
                            src={`${process.env.PUBLIC_URL}/images/system/header-step4.webp`}
                        />
                    </li>
                    <li>
                        {' '}
                        <img
                            onClick={() => {
                                setActiveBattleFlow('step5')
                                scrollToTop()
                            }}
                            className={` ${
                                activeBattleFlow === 'step5' && 'brightness-125'
                            }  hover:brightness-125 duration-300`}
                            alt='step5'
                            src={`${process.env.PUBLIC_URL}/images/system/header-step5.webp`}
                        />
                    </li>
                </ul>
            </nav>
        </>
    )
}
